<template>
  <svg
    class="icon"
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      class="icon__fill"
      x="4"
      y="9"
      width="12"
      height="2"
      rx="1"
      :fill="color"
    />
    <rect
      class="icon__fill"
      x="11"
      y="4"
      width="12"
      height="2"
      rx="1"
      transform="rotate(90 11 4)"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: "IconPlus",

  props: {
    // цвет иконки
    color: {
      type: String,
      default() {
        return this.$vuetify.theme.textPrimary;
      }
    },
    // размер
    size: {
      type: String,
      default: "20"
    }
  }
};
</script>
